import { TcDirectoryListingProps, TcDirectoryBroadDiseaseProps } from './_types';

const processDiseaseForTotals = ({
  diseases,
  map,
}: {
  diseases?: TcDirectoryBroadDiseaseProps[];
  map: Map<string, number>;
}) => {
  if (!diseases) {
    return;
  }
  diseases.forEach(({ fields }) => {
    if (!fields) {
      return;
    }
    const { stages, diseaseId: broadDiseaseId } = fields;
    if (!stages) {
      return;
    }
    stages.forEach((stage) => {
      const { fields: stageFields } = stage;
      if (!stageFields) {
        return;
      }
      const { diseaseId, total } = stageFields;
      const itemKey = `${broadDiseaseId.value}_${diseaseId.value}`;
      const currentValue = map.get(itemKey) ?? 0;
      map.set(itemKey, currentValue + (total?.value ?? 0));
    });
  });
};

export const getDiseaseTotals = ({ fields }: TcDirectoryListingProps): Map<string, number> => {
  const ret = new Map<string, number>();
  if (!fields) {
    return ret;
  }
  const { diseases } = fields;
  if (!diseases) {
    return ret;
  }
  const { autologus, related, unrelated } = diseases;
  processDiseaseForTotals({ diseases: autologus, map: ret });
  processDiseaseForTotals({ diseases: related, map: ret });
  processDiseaseForTotals({ diseases: unrelated, map: ret });
  return ret;
};
